import { Component, Inject, OnInit } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { IntakeField } from '../../intake-field'

@Component({
  selector: 'mmx-override-intake',
  templateUrl: './override-intake.component.html',
  standalone: false,
})
export class OverrideIntakeComponent implements OnInit {
  overrideForm: UntypedFormGroup

  constructor(
    public dialogRef: MatDialogRef<OverrideIntakeComponent>,
    @Inject(MAT_DIALOG_DATA) public info: IntakeField,
  ) {}

  ngOnInit(): void {
    this.overrideForm = new UntypedFormGroup({
      note: new UntypedFormControl(this.info.note),
    })
  }

  updateIntake() {
    const form = this.overrideForm.value
    this.info.note = form.note
    // update values
    this.dialogRef.close(this.info)
  }
}
